
import {connect} from "react-redux";
import {BoothProfileComponent} from "../components/BoothProfileComponent";
import {boothByIdSelector, shopByIdSelector} from "../../_data/selectors";

const mapDispatchToProps = (dispatch, props) => {
    return {};
};

const mapStateToProps = (state, props) => {

    return {
        shop: shopByIdSelector(state, parseInt(props.match.params.shopId)),
        booth: boothByIdSelector(state, parseInt(props.match.params.boothId))
    };
};

const BoothProfileContainer = connect(mapStateToProps, mapDispatchToProps)(BoothProfileComponent);
export default BoothProfileContainer;


// WEBPACK FOOTER //
// ./app/client/booth/containers/BoothProfileContainer.ts